import { render, staticRenderFns } from "./ListCustomerType.vue?vue&type=template&id=66f748c4&scoped=true"
import script from "./ListCustomerType.vue?vue&type=script&lang=js"
export * from "./ListCustomerType.vue?vue&type=script&lang=js"
import style0 from "./ListCustomerType.vue?vue&type=style&index=0&id=66f748c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f748c4",
  null
  
)

export default component.exports